import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import api, { VendorDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";

export interface VendorsGridProps {
  onRowSelected: (row: VendorDto | null) => void;
}

export const VendorsGrid = (props: VendorsGridProps) => {
  const { onRowSelected } = props;

  const loadData = async (page: number, size: number, sort: string, filter: string): Promise<PaginationData<VendorDto>> => {
    return await api.vendor.find({ page, size, sort, name: filter } as any);
  };

  const columns: GridColDef<VendorDto>[] = [
    { field: "name", headerName: "Name", minWidth: 200, flex: 400, editable: false, sortable: true, filterable: false },
    { field: "isEnabled", headerName: "Enabled", width: 80, editable: false, sortable: true, filterable: false, align: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
    { field: "createdAt", headerName: "Created", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
  ];

  return <PaginatedDataGrid loadData={loadData} columns={columns} onRowSelected={onRowSelected} showFilter />;
};
